import { ComponentBootstrap } from '@demant/wdh-react-bootstrap';
import BlogListApp from './react-blog-list';
var ReactBlogList = new ComponentBootstrap('blog-list');
ReactBlogList.reactApp = BlogListApp;
ReactBlogList.run();